<template>
    <div id="asset-localisation-widget-component">
        <v-card class="elevation-0">
            <v-card-title>
                <HeaderWidgetComponent
                    :is_open="is_open"
                    :title="$t('asset_localisation_widget_component.location')"
                    widget_name="asset-localisation-widget-component"
                />

                <v-expand-transition>
                    <v-card-text v-show="is_open">
                        <template v-if="asset.domicile">
                            <div class="d-flex gap-1 mb-4">
                                <v-icon>mdi-map-marker-outline</v-icon>
                                {{ displayToHumanDomicileAddress(asset.domicile) }}
                            </div>

                            <div class="d-flex gap-1 mb-4">
                                <v-icon>mdi-home</v-icon>
                                {{ asset.domicile.address_name }}
                            </div>

                            <div ref="mapContainer" class="google-map-container"></div>
                        </template>

                        <template v-else>
                            {{ $t('asset_localisation_widget_component.no_domicile_associated') }}
                        </template>
                    </v-card-text>
                </v-expand-transition>
            </v-card-title>
        </v-card>
    </div>
</template>

<script>
import maplibre from '@/mixin/maplibre'
import HeaderWidgetComponent from '@/components/equipment/widget/HeaderWidgetComponent.vue'

export default {
    name: 'AssetLocalisationWidgetComponent',
    components: { HeaderWidgetComponent },
    mixins: [maplibre],
    props: {
        asset: {
            type: Object,
            required: true,
        },
        is_open: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            isMapInitialized: false,
        }
    },
    computed: {
        mapCenter() {
            return {
                lat: parseFloat(this.asset.domicile.latitude),
                lng: parseFloat(this.asset.domicile.longitude),
            }
        },
    },
    watch: {
        is_open(open) {
            if (open) this.renderMap()
        },
    },
    mounted() {
        if (this.is_open) this.renderMap()
    },
    methods: {
        // The map lives inside a v-show block, so it must be initialized only once
        // the widget is open (a display:none container has no dimensions).
        renderMap() {
            if (!this.asset.domicile) return

            this.$nextTick(() => {
                if (this.isMapInitialized) {
                    this.resizeMapLibre()
                    return
                }

                this.initMapLibre(this.$refs.mapContainer, { center: this.mapCenter, zoom: 16 })
                this.setSingleMarker(this.mapCenter)
                this.isMapInitialized = true
            })
        },
        displayToHumanDomicileAddress(domicile, message = this.$t('asset_localisation_widget_component.no_associated_address')) {
            if (domicile) {
                return `${domicile.street_number ?? ''} ${domicile.address ?? ''}, ${domicile.postal_code ?? ''} ${domicile.city ?? ''}`
            }

            return message
        }
    }
}
</script>
